import { useContext } from 'react';

import { RouterContext } from '../client/Router';

export const useHistory = () => {
  const routerValue = useContext(RouterContext);

  if (typeof routerValue === 'undefined') {
    console.error(
      "[RouterContext] Couldn't find a context value; Please make sure to use it within <RouterContext.Provider>",
    );
    return;
  }

  return routerValue.history;
};
